<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								View Change Request
							</div>
				
							<div class="page_main">
								<div class="change-request-page">
									<el-form ref="form" :model="form" label-position="top" class="cr-form">
				
										<!-- Top Information -->
										<div class="form-grid">
				
											<!-- Left -->
											<div class="form-col">
												<el-form-item label="Request ID">
													<el-input v-model="form.request_id" readonly class="gray-input">
														<template slot="prepend" v-if="false"></template>
													</el-input>
												</el-form-item>
				
												<el-form-item label="Initiator">
													<el-input v-model="form.username" readonly class="gray-input"></el-input>
												</el-form-item>
				
												<el-form-item label="Status">
													<el-input v-model="form.status_name" readonly class="gray-input"></el-input>
												</el-form-item>
											</div>
				
											<!-- Right -->
											<div class="form-col">
												<el-form-item label="Change Request Creation Date">
													<el-input v-model="form.dateline" readonly class="gray-input"></el-input>
												</el-form-item>
				
												<!-- <el-form-item label="Initiator's Company">
													<el-input v-model="form.company_name" readonly class="gray-input"></el-input>
												</el-form-item> -->
				
												<el-form-item label="Initiator's Department">
													<el-input v-model="form.departments_id" readonly class="gray-input"></el-input>
												</el-form-item>
											</div>
				
										</div>
				
										<!-- Description -->
										<el-form-item label="Overall Description of Change Request" class="full-width-item">
											<el-input
												v-model="form.overall_description"
												type="textarea"
												:rows="5"
												readonly
												class="gray-input">
											</el-input>
										</el-form-item>
				
										<el-form-item label="Reason / Justification for Change Request" class="full-width-item">
											<el-input
												v-model="form.reason"
												type="textarea"
												:rows="5"
												readonly
												class="gray-input">
											</el-input>
										</el-form-item>
				
									</el-form>
				
									<!-- Documents -->
									<div class="table-card">
										<div class="table-card-header">
											<div class="table-title">
												Documents Included in the Change Request
											</div>
										</div>
				
										<el-table
											:data="tableData"
											border
											stripe
											header-cell-class-name="custom-table-header"
											cell-class-name="custom-table-cell"
											class="document-table">
				
											<el-table-column
												prop="ref"
												label="Document ID"
												min-width="140"
												sortable />
				
											<el-table-column
												label="Current Revision"
												min-width="150"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.old_vnumber || "N/A" }}
												</template>
											</el-table-column>
				
											<el-table-column
												prop="vnumber"
												label="New Revision"
												min-width="130"
												sortable />
				
											<el-table-column
												prop="vname"
												label="Document Name"
												min-width="160"
												sortable />
				
											<el-table-column
												prop="leixing_name"
												label="Document Type"
												min-width="130"
												sortable />
				
											<el-table-column
												prop="vdesc"
												label="Change Description"
												min-width="200"
												sortable />
				
											<el-table-column
												label="File"
												min-width="160"
												fixed="right">
												<template slot-scope="scope">
													<el-link
														type="primary"
														:underline="true"
														@click="handlePreview(scope.row)">
														{{ scope.row.image_info.name }}
													</el-link>
												</template>
											</el-table-column>
				
										</el-table>
									</div>
								</div>
				
								<div class="page-wrap">
				
									<div class="page-title">
										Workflow
									</div>
				
									<div class="flow-wrapper">
										<div
											v-for="(item, index) in flowList"
											:key="item.key"
											class="flow-item-wrap">
				
											<div :class="['flow-item',{ active:item.step == form.step }]">
												<span class="flow-text">
													{{ item.label }}
												</span>
											</div>
				
											<div
												v-if="index !== flowList.length - 1"
												class="flow-arrow">
												→
											</div>
				
										</div>
									</div>
				
									<div class="table-card">
				
										<div class="table-card-header">
											<div class="table-title">
												Task History
											</div>
										</div>
				
										<div>
				
											<div style="display:flex;justify-content:space-between;align-items:center;margin:10px;">
												<div>Total {{ matchCount }} Records</div>
				
												<el-input
													v-model="searchKeyword"
													placeholder="Enter keywords (space-separated supported)"
													clearable
													style="width:300px" />
											</div>
				
											<el-table
												ref="tableRef"
												:data="filteredTableData"
												border
												stripe
												class="history-table">
				
												<el-table-column
													prop="step_name"
													label="Task Name"
													min-width="150">
													<template #default="scope">
														<span v-html="highlight(scope.row.step_name)"></span>
													</template>
												</el-table-column>
				
												<el-table-column
													label="Assignee"
													min-width="150">
													<template #default="scope">
														<span v-html="highlight(scope.row.apply_username || 'Unassigned')"></span>
													</template>
												</el-table-column>
				
												<!-- <el-table-column
													label="Assignee's Company"
													min-width="180">
													<template #default="scope">
														<span v-html="highlight(scope.row.company_name || 'N/A')"></span>
													</template>
												</el-table-column> -->
				
												<el-table-column
													label="Assignee's Department"
													min-width="180">
													<template #default="scope">
														<span v-html="highlight(scope.row.departments_name || 'N/A')"></span>
													</template>
												</el-table-column>
				
												<el-table-column
													label="Task Status / Result"
													min-width="150">
													<template #default="scope">
														<span v-html="highlight(getStatusText(scope.row.status))"></span>
													</template>
												</el-table-column>
				
												<el-table-column
													prop="remark"
													label="Comment"
													min-width="210">
													<template #default="scope">
														<span v-html="highlight(scope.row.remark || '')"></span>
													</template>
												</el-table-column>
				
												<el-table-column
													prop="end_time"
													label="Due Date"
													min-width="150">
													<template #default="scope">
														<span v-html="highlight(scope.row.end_time)"></span>
													</template>
												</el-table-column>
				
												<el-table-column
													label="Completion Date"
													min-width="150">
													<template #default="scope">
														<span v-html="highlight(scope.row.app_time)"></span>
													</template>
												</el-table-column>
				
											</el-table>
				
										</div>
									</div>
				
									<div class="footer-btn">
										<el-button
											type="primary"
											@click="handleClose">
											Close
										</el-button>
									</div>
				
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { resourcesUpdateDetail } from "@/api/docManage/requestSearch/index";
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import moment from "moment";
export
default {
	components:{
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			keyword: "",
			form: {
				request_id: "",
				username: "",
				status_name: "",
				dateline: "",
				// company_name: "",
				departments_id: "",
				overall_description: "",
				reason: "",
				step: "",
			},
			tableData: [],
			taskKeyword: "",
			searchKeyword: '',
			originTableData: [],
			matchCount: 0,
			flowList: [
				{
					label: "Submit Request",
					step: 1
				},
				{
					label: "Initial Review",
					step: 2
				},
				{
					label: "Formal Review",
					step: 3
				},
				{
					label: "Document Release",
					step: 4
				},
				{
					label: "Completed",
					step: 5
				}
			],
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		//请求详情
		resourcesUpdateDetail({
			id: that.$route.query.id
		}).then((res) => {
			if (res.code == 200) {
				// console.log(res.data);
				that.form = {
					request_id: res.data.request_id,
					username: res.data.username,
					status_name: res.data.status_name,
					dateline: res.data.dateline,
					// company_name: res.data.company_name,
					departments_id: res.data.departments_id,
					overall_description: res.data.overall_description,
					reason: res.data.reason,
					step: res.data.step,
				};
				if (res.data.versioninfo) {
					that.tableData.push(res.data.versioninfo);
				}
				that.originTableData = res.data.apply_list;
			}
			that.isLoading = false;
		});
	},
	computed: {
		// 分词
		keywords() {
			if (!this.searchKeyword) return []
			return this.searchKeyword
				.toLowerCase()
				.split(/\s+/)
				.filter(Boolean)
		},
		// 过滤
		filteredTableData() {
			if (!this.keywords.length) {
				this.matchCount = this.originTableData.length
				return this.originTableData
			}
			const result = this.originTableData.filter(row => {
				return this.matchRow(row)
			})
			this.matchCount = result.length

			this.$nextTick(() => {
				this.scrollToFirst()
			})
			return result
		}
	},
	watch: {
		//
	},
	methods: {
		// 行匹配
		matchRow(row) {
			const fields = [
				row.step_name,
				row.apply_username || 'Unclaimed',
				// row.company_name || 'N/A',
				row.departments_name || 'N/A',
				this.getStatusText(row.status),
				row.remark || '',
				row.end_time,
				row.app_time
			]
			const text = fields.join(' ').toLowerCase()
			return this.keywords.every(k => text.includes(k))
		},
		// 状态映射
		getStatusText(status) {
			const map = {
				1: 'In Progress',
				2: 'Approved',
				3: 'Rejected',
				4: 'Auto Rejected',
				9: 'Withdrawn'
			}
			return map[status] || ''
		},
		// 高亮
		highlight(text) {
			if (!text) return ''
			let result = text.toString()
			this.keywords.forEach(k => {
				const reg = new RegExp(
					`(${k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
					'gi'
				)
				result = result.replace(reg, '<span class="highlight">$1</span>')
			})
			return result
		},
		// 滚动
		scrollToFirst() {
			const table = this.$refs.tableRef
			if (!table) return
			const el = table.$el.querySelector('.el-table__body-wrapper tbody tr')
			if (el) {
				el.scrollIntoView({ behavior: 'smooth', block: 'center' })
			}
		},
		//任务历史记录搜索
		handleSearch() {
			let that = this;
			console.log("任务历史记录");
		},
		handleInfo(row) {
			console.log("查看详情:", row);
		},
		handlePreview(row) {
			// window.open(row.image_info.url);
		},
		//取消
		handleClose() {
			window.close();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
::v-deep .table-card .highlight {
  background: linear-gradient(120deg, #f56c6c, #ff9a9e);
  color: #fff;
  padding: 0 3px;
  border-radius: 3px;
}
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}
::v-deep .btn span {
  text-decoration: underline;
}

.change-request-page {
  padding: 16px 20px 24px;
  min-height: 100%;
  box-sizing: border-box;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 28px;
  align-items: start;
}

.form-col {
  display: flex;
  flex-direction: column;
}

.full-width-item {
  margin-top: 8px;
}

/* label 样式 */
::v-deep .el-form-item__label {
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #2f343b;
  font-weight: 700;
}

/* 输入框统一风格 */
.gray-input ::v-deep .el-input__inner {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
.gray-input ::v-deep .el-textarea__inner {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  font-size: 14px;
}

.gray-input ::v-deep .el-input__inner[readonly], .gray-input ::v-deep .el-textarea__inner[readonly] {
  cursor: default;
}

.table-card {
  margin-top: 16px;
  border: 1px solid #d8dde3;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.table-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 14px 10px;
  background: #f5f6f7;
  border-bottom: 1px solid #d8dde3;
}

.table-title {
  font-size: 18px;
  font-weight: 700;
  color: #2f343b;
}

.table-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 230px;
}

.search-input ::v-deep .el-input__inner {
  border-radius: 8px;
  border: 1px solid #cfd5db;
  height: 40px;
  line-height: 40px;
}

.collapse-btn {
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 8px;
}

.document-table {
  width: 100%;
}

.document-table ::v-deep .custom-table-header {
  background: #f4f6f8;
  color: #2f343b;
  font-weight: 700;
  font-size: 14px;
  border-bottom: 2px solid #3c4043;
}

.document-table ::v-deep .custom-table-cell {
  color: #2f343b;
  font-size: 14px;
}

.document-table ::v-deep .el-table__cell {
  padding: 12px 8px;
}

.document-table ::v-deep .cell {
  word-break: break-word;
  line-height: 1.5;
}

.page-wrap {
  padding: 24px 24px 32px;
  box-sizing: border-box;
}

.page-title {
  margin-bottom: 18px;
  font-size: 24px;
  font-weight: 700;
  color: #222;
}

.flow-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  gap: 18px;
  width: 100%;
  margin: 0 auto 28px;
  padding: 18px 24px;
  overflow-x: auto;
  box-sizing: border-box;
}

.flow-item-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.flow-item {
  position: relative;
  min-width: 100px;
  min-height: 72px;
  padding: 0 26px;
  border: 1px solid #cfc8ff;
  border-radius: 10px;
  background: #ffffff;
  color: #1f2d3d;
  font-size: 17px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  text-align: center;
}

.flow-text {
  display: block;
  width: 100%;
  line-height: 0;
  text-align: center;
  white-space: pre-line;
}

.flow-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(15, 35, 95, 0.1);
}

.flow-item.active {
  border-color: #0b63c9;
  background: linear-gradient(180deg, #0b63c9 0%, #0052a3 100%);
  color: #fff;
  box-shadow: 0 8px 20px rgba(11, 99, 201, 0.22);
}

.flow-arrow {
  margin: 0 2px;
  font-size: 24px;
  font-weight: 700;
}

.footer-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px 0 16px;
}

/* 响应式 */
@media screen and (max-width: 1200px) {
  .form-grid {
    grid-template-columns: 1fr;
    row-gap: 0;
  }

  .table-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .table-tools {
    width: 100%;
  }

  .search-input {
    width: 100%;
  }
}
</style>

